import { render } from "./PpsNotFoundRcu.vue?vue&type=template&id=716e6fc0&scoped=true"
import script from "./PpsNotFoundRcu.vue?vue&type=script&lang=js"
export * from "./PpsNotFoundRcu.vue?vue&type=script&lang=js"

import "./PpsNotFoundRcu.vue?vue&type=style&index=0&id=716e6fc0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716e6fc0"]])

export default __exports__